/**
 * Example element from df-lit-starter (legacy teaching component).
 * Note: This component intentionally uses native button for backward compatibility
 * with existing tests. New components should use Material Design 3.
 */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
let MyElement = class MyElement extends LitElement {
    static { this.styles = css `
    :host {
      display: block;
      border: solid 1px gray;
      padding: 16px;
      max-width: 800px;
    }
  `; }
    constructor() {
        super();
        this.name = 'World';
        this.count = 0;
    }
    render() {
        /* eslint-disable @df/md3/enforce-md3 -- Legacy teaching component preserved for backward compatibility */
        const legacyTemplate = html `
      <h1>${this.sayHello(this.name)}!</h1>
      <button @click=${this.onClick} part="button">
        Click Count: ${this.count}
      </button>
      <slot></slot>
    `;
        /* eslint-enable @df/md3/enforce-md3 */
        return legacyTemplate;
    }
    onClick() {
        this.count += 1;
        this.dispatchEvent(new CustomEvent('count-changed'));
    }
    sayHello(name) {
        return `Hello, ${name}`;
    }
};
__decorate([
    property()
], MyElement.prototype, "name", void 0);
__decorate([
    property({ type: Number })
], MyElement.prototype, "count", void 0);
MyElement = __decorate([
    customElement('my-element')
], MyElement);
export { MyElement };
//# sourceMappingURL=my-element.js.map